// extracted by mini-css-extract-plugin
export default {"list":"src-ToastNotificationsList-module__list--kswY4"};